import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import StorefrontIcon from '@mui/icons-material/Storefront';

interface IconStoreProps {
  title: string;
}

const useStyles = makeStyles(({ spacing, palette }: Theme) => ({
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(1),
    color: palette.neutral[100],
  },
}));

export const StoreIcon = ({ title }: IconStoreProps): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.title}>
      <StorefrontIcon sx={{ fontSize: '20px' }} />
      {title}
    </div>
  );
};

export default StoreIcon;
